import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	videoTitle: {
		id: 'experiment-standard-differentiators.onboarding.video-tutorial.modal.video-title',
		defaultMessage: 'Get started with Confluence Standard',
		description: 'Video title shown in the onboarding modal',
	},
});
